module.exports = __webpack_public_path__ + "static/media/H1Y.e05c864c.jpg";